import { FC } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import RhfCheckboxGroup from 'components/CheckboxGroup/RhfCheckboxGroup/RhfCheckboxGroup';
import { If } from 'components/Generics';
import { RHFTextArea } from 'components/RHFTextArea/RHFTextArea';
import { OTHER } from 'constants/prescriptionConstants';
import {
  ANTERIOR_BITE_RAMPS,
  OVERBITE_IMPROVE_DEEP_BITE_LOWER,
  OVERBITE_IMPROVE_DEEP_BITE_UPPER,
  OVERBITE_OPTION_VALUES
} from 'constants/prescriptionOptions';
import { translate } from 'utils';
import { RemoveCheckedOptions } from 'utils/patientpageUtils';
import { isOtherOptionSelected } from 'utils/ultraPrescription.utils';

interface Props {
  isDisabled?: boolean;
}
const ImproveDeepBite: FC<Props> = ({ isDisabled }) => {
  const { watch, control } = useFormContext();
  const watchImproveDeepBiteUpper = watch(
    'treatmentSpecifications.ZenClearUltra.overbite.ImproveDeepBite.Upper.upper'
  );
  const watchImproveDeepBiteLower = watch(
    'treatmentSpecifications.ZenClearUltra.overbite.ImproveDeepBite.Lower.lower'
  );

  return (
    <div>
      <div className=' flex flex-row space-x-4 mb-2 '>
        <div className='mt-3 bg-black text-white flex justify-center items-center  w-6 h-6 rounded-full'>
          <span>U</span>
        </div>
        <Controller
          control={control}
          name={
            'treatmentSpecifications.ZenClearUltra.overbite.ImproveDeepBite.Upper.upper'
          }
          render={({ field }) => (
            <div className='w-full'>
              <RhfCheckboxGroup
                disabled={isDisabled}
                options={OVERBITE_IMPROVE_DEEP_BITE_UPPER}
                name='treatmentSpecifications.ZenClearUltra.overbite.ImproveDeepBite.Upper.upper'
                className='mt-1'
                checkBoxItemFont='md:text-17px text-sm flex flex-row space-x-10'
                onChange={(data, name, e) => {
                  field.onChange(RemoveCheckedOptions(data, OTHER, e));
                }}
              />
              {isOtherOptionSelected(watchImproveDeepBiteUpper) && (
                <div className='my-5'>
                  <RHFTextArea
                    name={
                      'treatmentSpecifications.ZenClearUltra.overbite.ImproveDeepBite.Upper.upperOtherText'
                    }
                    autogrow
                    inputProps={{
                      disabled: isDisabled,
                      placeholder: translate('settings.please_type_here')
                    }}
                    maxgrowHeight={260}
                  />
                </div>
              )}
              <If
                condition={watchImproveDeepBiteUpper?.find(
                  (item: any) =>
                    item?.value === OVERBITE_OPTION_VALUES.ANTERIOR_BITE_RAMPS
                )}
              >
                <div className='bg-CHINESE_WHITE p-4 rounded-2xl my-2 '>
                  <RhfCheckboxGroup
                    disabled={isDisabled}
                    options={ANTERIOR_BITE_RAMPS}
                    name='treatmentSpecifications.ZenClearUltra.overbite.ImproveDeepBite.Upper.anteriorBiteRamps'
                    className='mt-1'
                    checkBoxItemFont='md:text-17px text-sm flex flex-row space-x-10'
                  />
                </div>
              </If>
            </div>
          )}
        />
      </div>
      <div className='flex flex-row space-x-4 mb-2'>
        <div className='mt-3 bg-black text-white flex justify-center items-center  w-6 h-6 rounded-full'>
          <span>L</span>
        </div>
        <Controller
          control={control}
          name={
            'treatmentSpecifications.ZenClearUltra.overbite.ImproveDeepBite.Lower.lower'
          }
          render={({ field }) => (
            <div className='w-full'>
              <RhfCheckboxGroup
                disabled={isDisabled}
                options={OVERBITE_IMPROVE_DEEP_BITE_LOWER}
                name='treatmentSpecifications.ZenClearUltra.overbite.ImproveDeepBite.Lower.lower'
                className='mt-1'
                checkBoxItemFont='md:text-17px text-sm flex flex-row space-x-10'
                onChange={(data, name, e) => {
                  field.onChange(RemoveCheckedOptions(data, OTHER, e));
                }}
              />
              {isOtherOptionSelected(watchImproveDeepBiteLower) && (
                <div className='mt-5'>
                  <RHFTextArea
                    name={
                      'treatmentSpecifications.ZenClearUltra.overbite.ImproveDeepBite.Lower.lowerOtherText'
                    }
                    autogrow
                    inputProps={{
                      disabled: isDisabled,
                      placeholder: translate('settings.please_type_here')
                    }}
                    maxgrowHeight={260}
                  />
                </div>
              )}
            </div>
          )}
        />
      </div>
    </div>
  );
};
export default ImproveDeepBite;
